const win: any = window;
import { jumpToBuy } from './jumpAgreement';
import { showController } from '../show-controller';
import { handlePageToThs } from '../utils/utils';
const isShare = !win.F10Utils.getBroker() && win.F10Utils.getUrlParams('fromshare');
const isUse = showController('hitNewStock');
/**
 * 当前交易账户已申购成功的新股信息
 */
export const handleBuyAllStock = (flag: boolean, success: Function) => {
    if (isShare) {
        handlePageToThs();
        return;
    }
    if (isUse) {
        win.callNativeHandler('doMultiAccountApply',
            {bondSwitch: flag},
            (data: any) => {
                const res = data;
                success && success(res.code);
            }
        );
    } else {
        jumpToBuy('', '', '');
    }

}